<template>
  <v-dialog v-model="dialog" max-width="800px">
    <v-card>
      <v-card-title class="mx-3">
        <span
          class="red--text d-inline-block text-truncate"
          style="max-width: 640px"
        >
          {{
            $t("Material.materialNameWithCode", [
              material.material_code,
              material.material_name,
            ])
          }}
        </span>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false"
              >fa-times
            </v-icon>
          </template>
          <span>
            {{ $t("$vuetify.close") }}
          </span>
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-carousel
        v-if="material_album.length > 0"
        hide-delimiters
        cycle
        height="320"
      >
        <v-carousel-item
          v-for="(item, i) in material_album"
          :key="i"
          :src="item"
          contain
          @click.stop="$showFullscreenImages(material_album, i)"
        />
      </v-carousel>
      <v-card-text>
        <v-container>
          <v-row align="center" dense>
            <v-col cols="12">
              <v-chip small label dark color="primary" class="me-2">
                {{ $t("Material.Fields.standard") + $t("Global.colon") }}
                <span
                  v-if="
                    material &&
                    material.standard &&
                    material.standard.name.length > 12
                  "
                  :title="material.standard.name"
                  style="cursor: pointer"
                >
                  {{ material.standard.name.slice(0, 12) + "......" }}
                </span>
                <span v-else>
                  {{
                    material && material.standard ? material.standard.name : ""
                  }}
                </span>
              </v-chip>
              <v-chip small label dark color="primary" class="me-2">
                {{
                  material.hide_flg
                    ? $t("Material.hideFlgs.on")
                    : $t("Material.hideFlgs.off")
                }}
              </v-chip>
              <v-chip small label dark color="primary" class="me-2">
                {{
                  material.public_flg
                    ? $t("Material.publicFlgs.on")
                    : $t("Material.publicFlgs.off")
                }}
              </v-chip>
            </v-col>
            <v-col cols="12">
              <v-row no-gutters>
                <!-- <v-spacer class="d-none d-sm-inline" /> -->
                <v-col cols="3" class="text-left">
                  <span class="font-weight-bold">
                    {{ $t("Material.Fields.brand") + $t("Global.colon") }}
                  </span>
                  <span v-if="material.brand">
                    {{ material.brand }}
                  </span>
                </v-col>
                <v-col cols="3" class="text-left">
                  <span class="font-weight-bold">
                    {{ $t("Material.Fields.origin") + $t("Global.colon") }}
                  </span>
                  <span v-if="material.origin">
                    {{ material.origin }}
                  </span>
                </v-col>
                <v-col cols="3" class="text-left">
                  <span class="font-weight-bold">
                    {{ $t("Material.Fields.alcohol_flg") + $t("Global.colon") }}
                  </span>
                  {{
                    material.alcohol_flg
                      ? $t("Material.alcoholFlg.on")
                      : $t("Material.alcoholFlg.off")
                  }}
                </v-col>
                <v-col cols="3" class="text-left">
                  <span class="font-weight-bold">
                    {{
                      $t("Material.Fields.storage_conditions") +
                      $t("Global.colon")
                    }}
                  </span>
                  <span v-if="material.storage_conditions">
                    {{ material.storage_conditions }}
                  </span>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-divider class="my-2" />
          <v-row align="center" dense>
            <v-col cols="12" class="text-left">
              <span class="font-weight-bold">
                {{
                  $t("SupplierMaterials.Fields.suppllier") + $t("Global.colon")
                }}
              </span>
              <span v-if="material.suppliers && material.suppliers.length">
                <span
                  v-for="(item, i) in material.suppliers"
                  :key="i"
                  class="mr-1"
                >
                  {{ item.supplier_name }}
                  <span v-if="item.default_flg">
                    {{ $t("SupplierMaterials.Fields.default") }}
                  </span>
                  <span v-if="i != material.suppliers.length - 1">
                    {{ $t("Global.pause") }}
                  </span>
                </span>
              </span>
            </v-col>
            <v-col cols="3" class="text-left">
              <span class="font-weight-bold">
                {{
                  $t("SupplierMaterials.Fields.unit_order") + $t("Global.colon")
                }}
              </span>
              {{
                material.supply_standard_detail
                  ? material.supply_standard_detail.unit
                  : ""
              }}
            </v-col>
            <v-col cols="3" class="text-left">
              <span class="font-weight-bold">
                {{
                  $t("SupplierMaterials.Fields.in_price") + $t("Global.colon")
                }}
              </span>
              {{ $t("Global.money") }} {{ material.in_price | formatMoney }}
            </v-col>
            <v-col cols="3" class="text-left">
              <span class="font-weight-bold">
                {{
                  $t("SupplierMaterials.Fields.tax_flg") + $t("Global.colon")
                }}
              </span>
              <v-chip
                small
                label
                :color="
                  material.supplier && material.supplier.tax_flg
                    ? 'primary'
                    : 'grey'
                "
                text-color="white"
              >
                {{
                  material.supplier && material.supplier.public_flg
                    ? $t("SupplierMaterials.Fields.tax_on")
                    : $t("SupplierMaterials.Fields.tax_off")
                }}
              </v-chip>
            </v-col>
            <v-col cols="3" class="text-center">
              <span class="font-weight-bold">
                {{
                  $t("SupplierMaterials.Fields.tax_setting") +
                  $t("Global.colon")
                }}
              </span>
              <span v-if="material.supplier && material.supplier.tax_flg">
                {{ material.supplier.tax_rate | formatWithDotNoMoreThan(2) }} %
              </span>
              <span v-else>-</span>
            </v-col>
          </v-row>
          <v-divider class="my-2" />
          <v-row dense>
            <v-col class="text-subtitle-1 font-weight-bold">
              {{ $t("Material.Fields.detail") }}
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              {{ material.description }}
            </v-col>
          </v-row>
          <v-row dense width="100px">
            <v-col id="material-video"></v-col>
          </v-row>
          <v-row dense>
            <v-col id="material-comment"></v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import Materials from "@/api/materials";

export default {
  name: "MaterialDialog",

  props: { value: Number },

  computed: {
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    dialog: false,
    material: {},
    material_album: [],
    viewDetailUnit: false,
    currentDetailUnit: null,
  }),

  watch: {
    dialog: {
      handler() {
        this.$emit("input", null);
      },
    },
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = true;
          Materials.fetchOne(this.value).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.material = response.data.material;
              }
            }.bind(this)
          );
        }
      },
    },
    material: {
      handler() {
        var material_album = [];
        if (this.material.material_img)
          material_album.push(this.material.material_img);
        if (this.material.material_album)
          this.material.material_album.forEach((img) =>
            material_album.push(img)
          );
        this.material_album = material_album;
        var node = null;
        // 清理旧数据
        node = document.getElementById("material-video");
        if (node)
          node.childNodes.forEach((child) => {
            node.removeChild(child);
          });
        node = document.getElementById("material-comment");
        if (node)
          node.childNodes.forEach((child) => {
            node.removeChild(child);
          });
        // 设置新数据
        if (this.material.video) {
          node = document.getElementById("material-video");
          if (node) {
            var video = new DOMParser().parseFromString(
              this.material.video,
              "text/html"
            ).body.childNodes[0];
            if (document.body.clientWidth <= 320)
              video.setAttribute("width", "200px");
            else if (document.body.clientWidth <= 400)
              video.setAttribute("width", "260px");
            node.append(video);
          }
        }
        if (this.material.comment) {
          node = document.getElementById("material-comment");
          if (node)
            node.append(
              new DOMParser().parseFromString(
                this.material.comment,
                "text/html"
              ).body.childNodes[0]
            );
        }
      },
    },
  },
};
</script>